import classNames from 'classnames';
import React, { useRef } from 'react';
import { useDispatch } from 'react-redux';

import { actionTypes } from '../../store/actions/menuModal';
import { keyCodes } from '../../constants';

import CloseIcon from '../Icons/CloseIcon';
import TextField from '../TextField';

import { SearchIcon } from './SearchIcon';

import s from './index.module.css';

const cx = classNames.bind(s);

const DEFAULT_PLACEHOLDER = 'Поиск по номеру детали';

const SearchInput = ({ className, searchQuery, searchPlaceholder = DEFAULT_PLACEHOLDER, isSearchActive, onChange, onFocus, onReset }) => {
  const dispatch = useDispatch();
  let searchInputEl = useRef(null);

  const handleCrossClick = e => {
    if (e && e.stopPropagation) {
      e.stopPropagation();
    }
    
    const currentSearchEl = searchInputEl && searchInputEl.current;
    if (currentSearchEl) {
      currentSearchEl.blur();
    }
    dispatch({ type: actionTypes.TOGGLE_SEARCH, payload: false });
    dispatch({ type: actionTypes.CHANGE_SEARCH_QUERY, payload: '' })
  }

  const handleReset = (e) => {
    if (onReset) {
      onReset(e);
    } else {
      handleCrossClick(e);
    }
  }
  
  const onSearchFocus = () => {
    if (onFocus) {
      onFocus();
    } else {
      dispatch({ type: actionTypes.TOGGLE_SEARCH, payload: true });
    }
  }

  const handleChange = (e) => {
    if (onChange) {
      onChange(e);
    } else {
      const payload = (e && e.target && e.target.value) || '';
      dispatch({ type: actionTypes.CHANGE_SEARCH_QUERY, payload });
    }
  }

  const onKeyUp = (e) => {
    if (e.keyCode === keyCodes.ENTER && searchQuery) {
      window.location = `/products/${searchQuery}`;
    }
  }

  return (
    <div className={cx(s.search, { [s.searchWithText]: isSearchActive, [className]: !!className })}>
      <SearchIcon color={isSearchActive ? '#009DBC' : undefined} className={cx(s.searchIcon, { [s.searchIconActive]: isSearchActive })} />
      <label className={s.searchLabel}>
        <TextField
          placeholder={searchPlaceholder}
          className={s.searchInput}
          onFocus={onSearchFocus}
          onChange={handleChange}
          onKeyUp={onKeyUp}
          value={searchQuery}
          ref={searchInputEl}
        />
      </label>
      {isSearchActive && (
        <div className={s.searchReset} onClick={handleReset}>
          <CloseIcon width={11} height={11} color={'#7E7E7E'} />
        </div>
      )}
    </div>
  )
};

export default SearchInput;
